import { render, staticRenderFns } from "./LegPickerSheet.vue?vue&type=template&id=a2a8f7d4"
import script from "./LegPickerSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegPickerSheet.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports